import CryptoJS from "crypto-js"
import JSEncrypt from 'jsencrypt/bin/jsencrypt.min'

/**
 * aes密钥检测
 * @params {*} key aes密钥必须是16位
 */
function aesKeyCheck(key) {
	if (typeof key !== 'string') {
		return "$%!Gd*%3nk)['R2x"
	} else if (key.length > 16) {
		return key.slice(0, 16)
	} else if (key.length < 16) {
		const count = Math.ceil(16 / key.length)
		let new_key = ''
		for (let i = 0; i < count; i++) {
			new_key += key
		}
		return new_key.slice(0, 16)
	} else {
		return key
	}
}

/**
 *
 * @description AES CBC加密
 * @param {String} key
 * @param {*} text
 * @returns {String} string
 */
export function aesEncrypt(key, text) {
	if (!key || !text || !CryptoJS) {
		return ''
	}
	try {
		const s_key = CryptoJS.enc.Utf8.parse(aesKeyCheck(key))
		const s_text = CryptoJS.enc.Utf8.parse(text)
		const s_encrypted = CryptoJS.AES.encrypt(s_text, s_key, {
			iv: s_key,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7
		})
		return s_encrypted.toString()
	} catch(err) {
		console.log('AesEncrypt Error', err)
		return ''
	}
}

/**
 * @description AES加密 并把加密后数据中空格替换成+
 * @param {*} key 加密key
 * @param {*} text 待加密字符串
 * @returns string
 */
export function aesEncryptReplaceBlank(key, text) {
  const res = aesEncrypt(key, text)
  return res.replace(/\s/g, '+')
}

/**
 * @description AES解密
 * @param {*} key 解密key
 * @param {*} text 待解密字符串
 * @returns string
 */
export function aesDecrypt(key, text) {
  if (!key || !text || !CryptoJS) {
    return ''
  }
  try {
    const s_key = CryptoJS.enc.Utf8.parse(aesKeyCheck(key))
    const s_decrypt = CryptoJS.AES.decrypt(text, s_key, { iv: s_key, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
    return s_decrypt.toString(CryptoJS.enc.Utf8).toString()
  } catch (err) {
    console.log('AesDecrypt Error', err)
    return ''
  }
}

/**
 * rsa 公钥加密
 * @param {*} pub_key 公钥
 * @param {*} text 待加密字符串
 * @returns string
 */
export function rsaEncryptByPubkey(pub_key, text) {
  try {
    const encrypt = new JSEncrypt()
    encrypt.setPublicKey(pub_key)
    return encrypt.encrypt(text)
  } catch (error) {
    return ''
  }
}

export function rsaDecryptByPrivateKey(private_key, text) {
  try {
    const decrypt = new JSEncrypt()
    decrypt.setPrivateKey(private_key)
    return decrypt.decrypt(text)
  } catch (error) {
    return ''
  }
}

/**
 * base64加密
 * @param {*} string_data 待加密字符数
 * @returns string
 */
export function base64Encode(string_data) {
  try {
    const words = CryptoJS.enc.Utf8.parse(string_data)
    return CryptoJS.enc.Base64.stringify(words)
  } catch (error) {
    return ''
  }
}

/**
 * bae64 解密
 * @param {*} string_data 待解密字符串
 * @returns string
 */
export function base64Decode(string_data) {
  try {
    const words = CryptoJS.enc.Base64.parse(string_data)
    return words.toString(CryptoJS.enc.Utf8)
  } catch (error) {
    return ''
  }
}

/**
 * md5
 * @param {*} string
 * @returns
 */
export function MD5(str) {
  try {
    return CryptoJS.MD5(str).toString()
  } catch (error) {
    return ''
  }
}
